import {
  Button,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack
} from '@mui/material'
import '../../../Style/Pulse.css'
import { useState } from 'react'
import RTEView from '../../RichTextEditor/RTEView'

const MultipleChoiceExample = ({}) => {
  const section = {
    pulseGrid: {
      rows: ['Do you like pizza?', 'Do you like going on hikes?'],
      columns: ['Yes', 'No']
    }
  }
  const [userVotes, setUserVotes] = useState(
    section.pulseGrid.rows.map(row => {
      return { label: row, value: null }
    })
  )

  const handleChange = (value, rowIndex) => {
    setUserVotes(
      userVotes.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...row,
            value: value
          }
        }
        return row
      })
    )
  }

  return (
    <Stack
      spacing={{ xs: 1, md: 2 }}
      direction='column'
      justifyContent='center'
      useFlexGap
      sx={{ flexWrap: 'wrap', pb: { xs: 1, md: 2 } }}
    >
      {section.pulseGrid.rows.map((row, rowIndex) => (
        <Card raised key={'help' + rowIndex + 'row_MCGRID'}>
          <CardContent>
            <FormControl sx={{ width: '100%' }}>
              <Stack
                direction='row'
                justifyContent='space-between'
                sx={{ flexWrap: 'wrap', pb: { xs: 1, md: 2 }, width: '100%' }}
              >
                <FormLabel
                  id={'help' + rowIndex + 'row_MCGRID'}
                  sx={{ color: 'unset' }}
                >
                  <RTEView content={row} />
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby={'help' + rowIndex + 'row_MCGRID'}
                  sx={{ justifySelf: 'flex-end', ml: 'auto' }}
                  value={userVotes[rowIndex].value}
                  onChange={(_e, value) => handleChange(value, rowIndex)}
                >
                  {section.pulseGrid.columns.map((col, colIndex) => (
                    <FormControlLabel
                      key={'help' + rowIndex + 'row_' + colIndex + '_colMCGRID'}
                      value={col}
                      control={<Radio />}
                      label={col}
                    />
                  ))}
                </RadioGroup>
              </Stack>
            </FormControl>
          </CardContent>
        </Card>
      ))}
      <Button
        variant='contained'
        disabled={userVotes.some(row => !row.value)}
        sx={{ width: 'fit-content', ml: 'auto' }}
      >
        Save
      </Button>
    </Stack>
  )
}

export default MultipleChoiceExample
